import * as Yup from "yup";

import { createForm } from "../../../forms";

import type { TypeSafeReactLocalization } from "../../../../composites";

export type Method = "" | "freeform" | "template";

export type MethodSelectorFormFields = {
  method: Method;
};

const translateValidationSchema = ({ getString }: TypeSafeReactLocalization) =>
  Yup.object().shape({
    method: Yup.string().required(
      getString("form-generic-validation-required"),
    ),
  });

const initialValues: MethodSelectorFormFields = {
  method: "",
};

export const methodSelectorForm = createForm({
  initialValues,
  translateValidationSchema,
});
